<modal-layout-right (close)="close()">
    <ng-container ngProjectAs="[modalTitle]">
        <h4 class="h3">{{'Specifications' | translate}}</h4>
    </ng-container>

    <div ngProjectAs="[modalBody]"
         class="flex-m flex-s flex-justify-center-m flex-justify-center-s">
        <div class="w-12 w-11-m w-11-s p-l-2-m p-l-2-s p-r-2-m p-r-2-s custom-scrollbar overflow-x-hidden m-t-2-x m-t-2-l"
             style="overflow-y: auto;">
            @for (swatch of data.product.data!.features_section; track $index) {
            <div class="w-4 center m-b-2-m m-b-2-s">
                <img class="w-8 w-12-m w-12-s m-t-8 m-t-6-m m-t-6-s"
                     [ratio]="1"
                     [dfImage]="swatch | optionImage : 'features_section'">
            </div>
            }
        </div>
    </div>
</modal-layout-right>